import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { getProfile } from 'data/profile/selectors';
import { withStyles } from '@material-ui/core/styles';
import { replace } from 'connected-react-router';

import { getAuthSession, getDatasetId } from 'utils/auth/selectors';
import { getDatasetsById, getLoadPending as getDatasetsLoadPending, makeNewDataset } from 'data/datasets/selectors';
import * as datasetActions from 'data/datasets/actions';
import { authSelectDataset } from 'utils/auth/actions';
import { AuthSelectDatasetPayload } from 'utils/auth/types';
import GettingStartedWebFirst from 'containers/SetupPage/GettingStartedWebFirst';
import store from 'store';
import { getLoadPending as getFlagsLoadPending } from 'utils/featureFlags/selectors';
import { hasWebFirstEntitlements } from 'data/entitlements/entitlementsSelectors';
import { getAccountsById, getLoadPending as getAccountsLoadPending } from 'data/accounts/selectors';

import { getLogger } from 'utils/logger';

import SetupPageCompanion from './SetupPageCompanion';
import SetupPageWebFirst from './SetupPageWebFirst';

const log = getLogger('containers/SetupPage');


const styles = () => ({
  base: {
    fontWeight: 200,
    padding: 3,
  },
  title: {
    extend: 'base',
    fontSize: '25px',
    fontWeight: 400,
  },
  subTitle: {
    fontSize: '20px',
    extend: 'base',
  },
  bodyText: {
    fontWeight: 200,
    fontSize: '14px',
  },
  link: {
    cursor: 'pointer',
  },
});

const desktopClients = 'quicken_windows, quicken_mac';
const cloudClients = 'quicken_webapp';

class SetupPage extends PureComponent { // eslint-disable-line react/prefer-stateless-function

  static propTypes = {
    profile: PropTypes.object,
    classes: PropTypes.object,
    authSession: PropTypes.object,
    datasetId: PropTypes.string,
    datasetsById: PropTypes.object,
    isLoadPending: PropTypes.bool,
    dispatchCreateDatasetAction: PropTypes.func,
    dispatchSelectDatasetAction: PropTypes.func,
    redirect: PropTypes.func,
    webFirstEnabled: PropTypes.bool,
    accountsLoadPending: PropTypes.bool,
    accountsById: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      // showIntro: true,
      newDatasetClientId: null,
    }
  }

  passIntro = () => {
    // this.setState({ showIntro: false });
  };

  createNewDataset = (type) => {

    if (!type || desktopClients.indexOf(type) === -1) {
      log.log('Create Dataset Failed, you must pass a type of "quicken_windows" or "quicken_mac"');
    }
    let newDataset = makeNewDataset(store.getState());
    newDataset = newDataset.set('platform', type === 'quicken_windows' ? 'QWIN_MWF' : 'QMAC_MWF');

    this.props.dispatchCreateDatasetAction(newDataset);
    this.setState({newDatasetClientId: newDataset.clientId});
  };

  render() {

    const { datasetId, datasetsById, isLoadPending, webFirstEnabled, accountsLoadPending, accountsById } = this.props;
    const { newDatasetClientId } = this.state;

    // 1. Still loading, return nothing
    if (isLoadPending) {
      return <div/>;
    }

    // 2. new dataset was created? then open it and navigate to getting started
    //
    if (newDatasetClientId) {
      const newDataSet = datasetsById.find((dataset) => newDatasetClientId === dataset.clientId);
      if (newDataSet && newDataSet.id) {
        this.setState({newDatasetClientId: undefined});
        this.props.dispatchSelectDatasetAction(new AuthSelectDatasetPayload({ dataset: newDataSet, reload: false, location: '/getting-started-webfirst' }));
      }
      return <div/>;
    }

    const datasetObject = datasetsById && datasetsById.get(datasetId);
    const createdByClientId = datasetObject && datasetObject.createdByClientId || 'unknown';
    // This indicates the dataset has been created by Windows or Mac, we cannot ascertain if it is unused,
    // or just unsynced.  In this case they get the "companion" setup page to either instruct them how to
    // sync their desktop accounts, or they can start from scratch with a web-created (web first) dataset
    //

    // 3. if dataset and it is created by cloud, then go to webfirst setup
    if (cloudClients.indexOf(createdByClientId) !== -1) {
      // window.location.replace('/getting-started-webfirst');
      return <GettingStartedWebFirst />;
    }
    const useCompanion = (desktopClients.indexOf(createdByClientId) !== -1) || !webFirstEnabled;

    if (!isLoadPending && !useCompanion && datasetsById.size === 0 && webFirstEnabled) {
      this.props.redirect('platformSelector');
    }

    // 4. no dataset or non-desktop datasset, show video
    // if (showIntro && !useCompanion) {
    //   return <SetupIntroVideo onContinue={this.passIntro}/>;
    // }


    // There is no dataset, or the dataset is from the desktop
    //

    // If the user is in setup page and synced his accounts redirect to dashboard
    if (!accountsLoadPending && accountsById?.size >= 1) {
      this.props.redirect('');
    }

    return (
      <>
        {useCompanion &&  // dataset is from the desktop
          <SetupPageCompanion
            {...this.props}
            defaultTabIsWindows={createdByClientId === 'quicken_windows'}
            onCreateDataset={this.createNewDataset}
          />
        }
        {!useCompanion &&  // no dataset
        <SetupPageWebFirst
          {...this.props}
          defaultTabIsWindows={createdByClientId === 'quicken_windows'}
          onCreateDataset={this.createNewDataset}
        />
        }
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: getProfile(state),
    authSession: getAuthSession(state),
    datasetId: getDatasetId(state),
    datasetsById: getDatasetsById(state),
    isLoadPending: getDatasetsLoadPending(state) || getFlagsLoadPending(state),
    webFirstEnabled: hasWebFirstEntitlements(state),
    accountsById: getAccountsById(state),
    accountsLoadPending: getAccountsLoadPending(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchCreateDatasetAction: (dataset) => dispatch(datasetActions.createDataset(dataset)),
    dispatchSelectDatasetAction: (data) => dispatch(authSelectDataset(data)),
    redirect: (location) => dispatch(replace(location)),
  };
}

export default compose(
  withStyles(styles, {withTheme: true}),
  connect(mapStateToProps, mapDispatchToProps),
)(withRouter(SetupPage));
